import { library } from "@fortawesome/fontawesome-svg-core";
import {
  faAnglesLeft,
  faAnglesRight,
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowUp,
  faArrowsUpDown,
  faBriefcase,
  faBroom,
  faBuilding,
  faCalendarDays,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faChevronLeft,
  faChevronRight,
  faCircle,
  faCircleNotch,
  faCircleQuestion,
  faClock,
  faClockRotateLeft,
  faClone,
  faCloud,
  faCloudBolt,
  faCloudMoon,
  faCloudMoonRain,
  faCloudRain,
  faCloudShowersHeavy,
  faCloudSun,
  faCloudSunRain,
  faCogs,
  faDollarSign,
  faCodeCompare,
  faDownload,
  faDroplet,
  faEllipsisH,
  faEnvelope,
  faEye,
  faFireFlameSimple,
  faGauge,
  faGlassWater,
  faGlobe,
  faHandshake,
  faHome,
  faInfoCircle,
  faLink,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMobileScreenButton,
  faMoon,
  faNewspaper,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPhone,
  faPlus,
  faScrewdriverWrench,
  faSeedling,
  faShareNodes,
  faSmog,
  faSnowflake,
  faSort,
  faSortDown,
  faSortUp,
  faSun,
  faSync,
  faTemperatureHalf,
  faTemperatureHigh,
  faThermometerHalf,
  faThumbtack,
  faTimes,
  faTint,
  faTrashCan,
  faTriangleExclamation,
  faUmbrella,
  faUsd,
  faUser,
  faUserGroup,
  faUserShield,
  faUserTie,
  faUsers,
  faWheatAwn,
  faWind,
} from "@fortawesome/free-solid-svg-icons";
import {
  Navigate,
  Outlet,
  Route,
  BrowserRouter as Router,
  Routes,
  useMatch,
  useParams,
} from "react-router-dom";
import { AuthRoute } from "./components/AuthRoute";
import { CookieConsent } from "./components/common/CookieConsent";
import { MobileNavbar } from "./components/MobileNavbar";
import { Navbar } from "./components/Navbar";
import { ProtectedRoute } from "./components/ProtectedRoute";
import { RoleRoute } from "./components/RoleRoute";
import { RootRedirect } from "./components/RootRedirect";
import { RotatePhoneOverlay } from "./components/RotatePhoneOverlay";
import { BreedingsTable } from "./components/screens/breeding/BreedingsTable";
import { BreedingDetailPage } from "./components/screens/breeding/farmer/BreedingDetailPage";
import { BreedingPage } from "./components/screens/breeding/farmer/BreedingPage";
import { ClientBreedingsPage } from "./components/screens/breeding/installer/ClientBreedingsPage";
import { Recharts } from "./components/screens/charts/Recharts";
import { ComingSoonPage } from "./components/screens/ComingSoonPage";
import { ConfirmRegistrationPage } from "./components/screens/ConfirmRegistrationPage";
import { AddWidgetCatalogPage } from "./components/screens/dashboard/AddWidgetCatalogPage";
import { AddWidgetConfigurePage } from "./components/screens/dashboard/AddWidgetConfigurePage";
import { DashboardGrid } from "./components/screens/dashboard/Dashboard";
import { DeleteAccountConfirmationPage } from "./components/screens/DeleteAccountConfirmationPage";
import { DevicesTable } from "./components/screens/device/DevicesTable";
import {
  DeviceViewMe,
  DeviceViewUuid,
} from "./components/screens/device/DeviceView";
import { ForgotPasswordConfirmationPage } from "./components/screens/ForgotPasswordConfirmationPage";
import { ForgotPasswordPage } from "./components/screens/ForgotPasswordPage";
import { HistoryPage } from "./components/screens/history/HistoryPage";
import { LoginPage } from "./components/screens/LoginPage";
import { PartnershipsPage } from "./components/screens/partnership/PartnershipsPage";
import { CollaboratorsPage } from "./components/screens/collaborator/CollaboratorsPage";
import {
  PROFILE_ACCOUNT_PATH,
  PROFILE_PRIVACY_PATH,
  PROFILE_SECURITY_PATH,
} from "./components/screens/profile/profileNav";
import { ProfilePage } from "./components/screens/profile/ProfilePage";
import { RegisterCompanyPage } from "./components/screens/RegisterCompanyPage";
import { RegisterPage } from "./components/screens/RegisterPage";
import { ResetPasswordPage } from "./components/screens/ResetPasswordPage";
import { SelectFarmTypePage } from "./components/screens/SelectFarmTypePage";
import { BreederHome } from "./components/screens/setup/BreederHome";
import { SetupBreedingPage } from "./components/screens/setup/SetupBreedingPage";
import { SetupBuildingsPage } from "./components/screens/setup/SetupBuildingsPage";
import { SetupDevicesPage } from "./components/screens/setup/SetupDevicesPage";
import { SetupSummaryPage } from "./components/screens/setup/SetupSummaryPage";
import { SetupWelcomePage } from "./components/screens/setup/SetupWelcomePage";
import { UsersTable } from "./components/screens/user/UsersTable";
import { WelcomeTour } from "./components/tour/WelcomeTour";
import { useLayoutMode } from "./hooks/useLayoutMode";
import "./i18n/i18n";

library.add(
  faArrowLeft,
  faArrowPointer,
  faArrowRight,
  faArrowUp,
  faArrowsUpDown,
  faBriefcase,
  faBroom,
  faBuilding,
  faCalendarDays,
  faChartLine,
  faCheck,
  faCheckCircle,
  faChevronDown,
  faAnglesLeft,
  faAnglesRight,
  faChevronLeft,
  faChevronRight,
  faSort,
  faSortDown,
  faSortUp,
  faCircle,
  faCircleNotch,
  faCircleQuestion,
  faClock,
  faClockRotateLeft,
  faClone,
  faCloud,
  faCloudBolt,
  faCloudMoon,
  faCloudMoonRain,
  faCloudRain,
  faCloudShowersHeavy,
  faCloudSun,
  faCloudSunRain,
  faCogs,
  faDollarSign,
  faCodeCompare,
  faDownload,
  faDroplet,
  faEllipsisH,
  faEnvelope,
  faEye,
  faGauge,
  faGlassWater,
  faGlobe,
  faHandshake,
  faHome,
  faInfoCircle,
  faLink,
  faLocationDot,
  faLock,
  faMagnifyingGlass,
  faMoon,
  faNewspaper,
  faPaperPlane,
  faPen,
  faPenToSquare,
  faPhone,
  faPlus,
  faScrewdriverWrench,
  faSeedling,
  faShareNodes,
  faSmog,
  faSnowflake,
  faSun,
  faSync,
  faTemperatureHalf,
  faTemperatureHigh,
  faThermometerHalf,
  faThumbtack,
  faTimes,
  faTint,
  faTrashCan,
  faTriangleExclamation,
  faUmbrella,
  faUser,
  faUserGroup,
  faUserShield,
  faUserTie,
  faUsers,
  faWheatAwn,
  faWind,
  faFireFlameSimple,
  faUsd,
  faMobileScreenButton
);

// Layout avec navbar
export const DashboardLayout = () => {
  const layout = useLayoutMode();
  // La vue distante est la seule page qui accepte le téléphone tourné : l'écran du produit
  // est lui-même en paysage. Même motif pour les quatre espaces (`/admin/device/:uuid`…).
  const isRemoteView = useMatch("/:space/device/:id") !== null;

  return (
    <div className="flex">
      {layout === "desktop" && <Navbar />}
      {/* `min-w-0` : un enfant flex a `min-width:auto` et REFUSE de se reduire sous la
          largeur de son contenu. Sans ca, un UUID ou une adresse IP un peu longue pousse
          toute la page au-dela du viewport et l'ecran defile horizontalement sur mobile. */}
      <main className={`flex-1 min-w-0 ${layout === "mobile" ? "pb-16" : ""}`}>
        <Outlet />
      </main>
      {layout === "mobile" && <MobileNavbar />}
      {layout === "phone-landscape" && !isRemoteView && <RotatePhoneOverlay />}
      {/* Dans le layout : cible la navigation et survit au changement de page. */}
      <WelcomeTour />
    </div>
  );
};

// Layout sans navbar
export const AuthLayout = () => {
  return (
    <main className="w-full">
      <Outlet />
    </main>
  );
};

// Alias legacy paramétrés : conservent le param en redirigeant vers /admin/*.
const LegacyDeviceRedirect = () => {
  const { uuid } = useParams();
  return <Navigate to={`/admin/device/${uuid}`} replace />;
};

function App() {
  return (
    <Router>
      <Routes>
        {/* Routes avec authentification (sans navbar) */}
        <Route element={<AuthRoute />}>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/register" element={<RegisterPage />} />
          <Route path="/register/company" element={<RegisterCompanyPage />} />
          <Route path="/register/farm-type" element={<SelectFarmTypePage />} />
          <Route
            path="/register/confirm"
            element={<ConfirmRegistrationPage />}
          />
          <Route path="/forgot-password" element={<ForgotPasswordPage />} />
          <Route
            path="/forgot-password/confirmation"
            element={<ForgotPasswordConfirmationPage />}
          />
          <Route path="/reset-password" element={<ResetPasswordPage />} />
          <Route
            path="/account/delete/confirmation"
            element={<DeleteAccountConfirmationPage />}
          />
        </Route>

        {/* Point d'entrée : aiguille vers l'espace selon le type */}
        <Route path="/" element={<RootRedirect />} />

        {/* Un seul layout pour tous les espaces : la navbar survit au passage d'un groupe
            de routes a l'autre (profil -> dashboard), ce qui garde son etat et permet
            d'animer le sous-menu profil a la fermeture. */}
        <Route element={<DashboardLayout />}>
          {/* Communs à tous les espaces (token seul) : profil + parcours d'ajout de widget.
              Les widgets sont partagés car le dashboard (DashboardGrid) est utilisé par TOUS les
              espaces, et le FAB / configurateur naviguent en dur vers /widgets et /. */}
          <Route element={<ProtectedRoute />}>
            <Route
              path={PROFILE_ACCOUNT_PATH}
              element={<ProfilePage tab="account" />}
            />
            <Route
              path={PROFILE_SECURITY_PATH}
              element={<ProfilePage tab="security" />}
            />
            <Route
              path={PROFILE_PRIVACY_PATH}
              element={<ProfilePage tab="privacy" />}
            />
            <Route path="/widgets" element={<AddWidgetCatalogPage />} />
            <Route
              path="/widgets/:widgetType/configure"
              element={<AddWidgetConfigurePage />}
            />
          </Route>

          {/* Espace ADMIN (admin, psc) */}
          <Route element={<RoleRoute space="admin" />}>
            <Route path="/admin" element={<DashboardGrid />} />
            <Route path="/admin/users" element={<UsersTable />} />
            {/* Historique, 2 onglets. L'onglet actif vient de l'URL (et non d'un
                useState) : lien partageable + bouton Retour fonctionnel.
                L'ancienne URL reste l'onglet par défaut, rien ne casse. */}
            <Route
              path="/admin/remote-connections"
              element={<HistoryPage tab="remote" />}
            />
            <Route
              path="/admin/remote-connections/logins"
              element={<HistoryPage tab="login" />}
            />
            <Route
              path="/admin/remote-connections/licenses"
              element={<HistoryPage tab="license" />}
            />
            <Route path="/admin/breedings" element={<BreedingsTable />} />
            {/*<Route path="/admin/buildings" element={<BuildingsTable />} />*/}
            <Route path="/admin/devices" element={<DevicesTable />} />
            <Route path="/admin/device/:uuid" element={<DeviceViewUuid />} />
            <Route path="/admin/device/me" element={<DeviceViewMe />} />
            <Route path="/admin/recharts" element={<Recharts />} />
          </Route>

          {/* Espaces client : même dashboard à widgets que l'admin (scopé au user via token) */}
          <Route element={<RoleRoute space="breeder" />}>
            <Route path="/breeder" element={<BreederHome />} />
            {/* Connexion à distance depuis le widget bâtiment (œil) : c'est SON régulateur, un
                éleveur doit pouvoir l'ouvrir. Même composant que l'admin ; le back filtre par
                token. Installateur / groupement : à décider plus tard (2026-07-30). */}
            <Route path="/breeder/device/:uuid" element={<DeviceViewUuid />} />
            <Route path="/breeder/device/me" element={<DeviceViewMe />} />
            <Route path="/breeder/devices" element={<DevicesTable />} />
            <Route path="/breeder/breedings" element={<BreedingPage />} />
            <Route
              path="/breeder/breedings/:breedingId"
              element={<BreedingDetailPage />}
            />
            <Route
              path="/breeder/partnerships"
              element={<PartnershipsPage />}
            />
            <Route path="/breeder/recharts" element={<Recharts />} />
            <Route
              path="/breeder/collaborators"
              element={<CollaboratorsPage />}
            />

            {/* Mise en route : des pages de l'espace comme les autres, navbar comprise —
                un parcours plein écran donnait l'impression d'être ressorti du site. */}
            <Route
              path="/breeder/mise-en-route"
              element={<SetupWelcomePage />}
            />
            <Route
              path="/breeder/mise-en-route/elevage"
              element={<SetupBreedingPage />}
            />
            <Route
              path="/breeder/mise-en-route/:breedingId/batiments"
              element={<SetupBuildingsPage />}
            />
            <Route
              path="/breeder/mise-en-route/:breedingId/produits"
              element={<SetupDevicesPage />}
            />
            <Route
              path="/breeder/mise-en-route/:breedingId/recapitulatif"
              element={<SetupSummaryPage />}
            />
          </Route>

          <Route element={<RoleRoute space="installer" />}>
            <Route path="/installer" element={<DashboardGrid />} />
            <Route path="/installer/devices" element={<DevicesTable />} />
            <Route
              path="/installer/breedings"
              element={<ClientBreedingsPage />}
            />
            <Route
              path="/installer/breedings/:breedingId"
              element={<BreedingDetailPage />}
            />
            {/* Partenariats : même page pour les 3 espaces client, une route par espace
                (RoleRoute renverrait un éleveur sur /breeder s'il ouvrait celle d'un autre). */}
            <Route
              path="/installer/partnerships"
              element={<PartnershipsPage />}
            />
            {/* Vue à distance : accessible depuis que le partage de produits existe. Le
                backend filtre déjà ce que l'installateur peut ouvrir (possession OU partage
                via partenariat accepté) — cf. link.DeviceAccessCondition. */}
            <Route
              path="/installer/device/:uuid"
              element={<DeviceViewUuid />}
            />
            <Route
              path="/installer/collaborators"
              element={<CollaboratorsPage />}
            />
            <Route
              path="/installer/history"
              element={<ComingSoonPage section="section_history" />}
            />
          </Route>

          <Route element={<RoleRoute space="group" />}>
            <Route path="/group" element={<DashboardGrid />} />
            <Route path="/group/partnerships" element={<PartnershipsPage />} />
            <Route path="/group/device/:uuid" element={<DeviceViewUuid />} />
          </Route>
        </Route>

        {/* Alias legacy → /admin/* (rien ne casse) */}
        <Route path="/users" element={<Navigate to="/admin/users" replace />} />
        <Route
          path="/devices"
          element={<Navigate to="/admin/devices" replace />}
        />
        <Route
          path="/device/me"
          element={<Navigate to="/admin/device/me" replace />}
        />
        <Route path="/device/:uuid" element={<LegacyDeviceRedirect />} />
        <Route
          path="/recharts"
          element={<Navigate to="/admin/recharts" replace />}
        />
      </Routes>
      <CookieConsent />
    </Router>
  );
}

export default App;
